import { useMediaQuery, useTheme } from "@mui/material";
import { MOBILE } from "consts/breakpoints";

const useDeviceType = () => {
  const { breakpoints } = useTheme();
  // theme `xs` is 0 (so legacy xs-keyed Grid props work on phones), so the
  // 530px "mobile" tier comes straight from the breakpoint constant.
  const isMobile = useMediaQuery(`(max-width:${MOBILE}px)`);
  const isSmallTablet = useMediaQuery(breakpoints.down("sm"));
  const isTablet = useMediaQuery(breakpoints.down("md"));
  const isSmallLaptop = useMediaQuery(breakpoints.down("lg"));
  const isBigScreen = useMediaQuery(breakpoints.up("lg"));

  return {
    isMobile,
    isSmallTablet,
    isTablet,
    isSmallLaptop,
    isBigScreen,
  };
};

export default useDeviceType;
